<section class="flex flex-col m-2.5 grow">
    <app-management-list-header
        [asAction]="false"
        [title]="'operator' | transloco"
        (search)="search($event)" />

    <ul class="p-0 grid grid-cols-2 grow">
        @if (paginatedData()) {
            <li
                class="p-2 flex flex-row items-center cursor-pointer gap-1 hover:text-custom-blue hover:bg-custom-light-blue"
                (click)="toggleSelect.emit({ all: true })">
                <app-checkbox [checkboxState]="allSelected() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
                <p class="!m-0">{{ 'selectAll' | transloco }}</p>
            </li>
            @for (people of paginatedData()!.items; track people.id) {
                <li
                    class="p-2 flex flex-row items-center cursor-pointer gap-1 hover:text-custom-blue hover:bg-custom-light-blue"
                    (click)="toggleSelect.emit({ all: false, id: people.id })">
                    <app-checkbox
                        [checkboxState]="
                            selectedItems().includes(people.id) ? CheckboxState.CHECKED : CheckboxState.UNCHECKED
                        " />
                    <p class="!m-0">{{ people.fullName }}</p>
                </li>
            }
        } @else {
            <app-loading />
        }
    </ul>
    <app-paginator
        #paginator
        [take]="paginatedData()!.take"
        [totalItems]="paginatedData()!.totalItems"
        (onPageChange)="onPaginationChange($event)" />
</section>
